import React from 'react';
import { ShoppingcartIcon } from '../../atoms/Icon';
var MenuCart = function MenuCart(_ref) {
  var _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function (_event) {
      return undefined;
    } : _ref$onClick,
    numberOfItemsInCart = _ref.numberOfItemsInCart;
  var handleClick = function handleClick(event) {
    event.stopPropagation();
    onClick(event);
  };
  return /*#__PURE__*/React.createElement("button", {
    className: "menu-cart__button",
    onClick: handleClick,
    "aria-label": "Kasse"
  }, /*#__PURE__*/React.createElement("div", {
    className: "menu-cart__icon-container"
  }, /*#__PURE__*/React.createElement(ShoppingcartIcon, null), /*#__PURE__*/React.createElement("span", {
    className: "menu-cart__item-count"
  }, /*#__PURE__*/React.createElement("span", {
    className: "menu-cart__item-count-text"
  }, numberOfItemsInCart))));
};
export default MenuCart;